import { FiltersDropdownProps } from './filters-dropdown.props';

export const FiltersDropdownPresets: FiltersDropdownProps = {
  count: 0,
};
